import React, { useContext, useEffect } from 'react'; // eslint-disable-line no-unused-vars
import { StateContext } from "../state";
import { get } from "lodash/object";
import { MAP_PAYMENT_STATUS_TO_UI_ERROR_TYPE, PAYMENT_STATUSES } from "../utils/enums";
import { actions } from "../state";
import { logUiError } from "../utils/logging";

export const ExceptedPayment = () => {
  const [applicationState, dispatch] = useContext(StateContext);
  const { payment, configuration } = applicationState;

  useEffect(() => {
    const paymentStatus = get(payment, 'status');
    if([PAYMENT_STATUSES.EXPIRED, PAYMENT_STATUSES.CANCELLED, PAYMENT_STATUSES.ARCHIVED, PAYMENT_STATUSES.FAILED, PAYMENT_STATUSES.RETURNED, PAYMENT_STATUSES.REFUNDED].includes(paymentStatus)){

      const errorType = MAP_PAYMENT_STATUS_TO_UI_ERROR_TYPE[paymentStatus];

      dispatch(actions.modals.showUiErrorModal(configuration, {
        errorType,
        contentProps: {
          showFaqLink: false,
        },
      }));

      logUiError(errorType, applicationState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default ExceptedPayment;
